import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { WorkstationService } from 'src/app/service/security/workstation.service';
import { ListComponent } from '../../core/list/list.component';
import { PopConfirmComponent } from '../../core/pop-confirm/pop-confirm.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-workstation-list',
  templateUrl: './workstation-list.component.html',
  styleUrls: ['./workstation-list.component.scss'],
})
export class WorkstationListComponent extends ListComponent {
  showChildForm: boolean = true; //

  selectedItem: any; //représente l'entité actuellement sélectionnée

  selectedRow: any = null; //représente, dans le matTAble la ligne en cours de sélection...

  childHaveChanges: boolean; //indique si le panneau ENFANT contient une modification
  needRefresh: boolean = false;

  TitreGlobalPage: string = 'Gestion des stations de travail';
  NomEntiteCourante: string = 'station';

  constructor(protected httpClient: HttpClient, private dialog: MatDialog, private workstationService: WorkstationService, private cdRef: ChangeDetectorRef) {
    super(httpClient);
    this.endpoint = 'workstations';

    this.autoload = true;
    this.rechercheOverrideGlobalSearchFilterFields = ['WorkStationCode', 'FullName'];
    this.champs = [
      {
        key: 'id',
        nom: 'id',
        type: 'number',
      },
      {
        key: 'WorkStationCode',
        nom: 'WorkStationCode',
        type: 'string',
      },
      {
        key: 'FullName',
        nom: 'FullName',
        type: 'string',
      },
      {
        key: 'CurrentLoggedUser_UserCode',
        nom: 'CurrentLoggedUser_UserCode',
        type: 'string',
      },
      {
        key: 'CurrentLoggedUser_StartTime',
        nom: '  ',
        type: 'datetime',
      },
    ];
    this.defaultOrderBy = 'WorkStationCode asc';
  }

  openForm(MyRow: any) {
    this.selectedItem = MyRow;

    this.showChildForm = true;
  }

  //evenement, issue du child, indiquant qu'on veut afficher ou masquer le FORM
  OnChildFormVisibilityChanged(val: boolean): void {
    if (val === false && this.childHaveChanges === true) this.popUpConfirmDiscard();
    else this.showChildForm = val;

    if (this.needRefresh === true) {
      this.launchRefresh();
      this.needRefresh = false;
    }
  }

  onChangeChildState(val: any): void {
    this.childHaveChanges = val;
    if (val === true) this.needRefresh = true;
    this.cdRef.detectChanges(); //bidouille, car la valeur childHaveChanges pointe sur un Ngif..et que c'Est ca- https://stackoverflow.com/questions/43375532/expressionchangedafterithasbeencheckederror-explained
  }

  createNew() {
    this.selectedItem = null;
    this.showChildForm = true;
  }

  //ici, c'est qu'on a cliqué sur le panneau de protection de 'changement détecté'.  ca permet de faire un DISCARD
  popUpConfirmDiscard() {
    let test = 'bla';
    // pop dialog

    const dialogRef = this.dialog.open(PopConfirmComponent, {
      data: {
        titre: 'Changements non sauvegardés',
        texte:
          'Attention! Des changements ont été détectés dans votre formulaire.  Voulez-vous IGNORER ces changementes ou POURSUIVRE la modification à droite?',
        affirmativeActionName: 'Poursuivre',
        affirmativeActionColor: 'primary',

        dismissiveActionName: 'Ignorer',
        dismissiveActionColor: 'warn',
      },
    });

    // after close dialog
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        return;
      }

      this.showChildForm = false;
      this.childHaveChanges = false;
    });
  }
}
